// @flow
import * as React from 'react'
import moment from 'moment-timezone'
import type { Gathering, School } from 'types'
import { H2, H6 } from 'ui/Typography'

type Props = {
  gathering: Gathering,
  school: School,
}

export default class GatheringPageBigDate extends React.Component<Props> {
  render = () => {
    return (
      <div className="GatheringPage-bigDate">
        <H2>{this.formatBeginsAt('DD')}</H2>
        <H6>{this.formatBeginsAt('MMM')}</H6>
      </div>
    )
  }

  formatBeginsAt = (format: string): string => {
    return moment(this.props.gathering.beginsAt).tz(this.props.school.timezone).format(format)
  }
}
